// extracted by mini-css-extract-plugin
module.exports =  {"text":"TextLabel-module__text--m8YFF","textProfit":"TextLabel-module__textProfit--Y5tOz","rect":"TextLabel-module__rect--TpAPO","rectProfit":"TextLabel-module__rectProfit--w5bSQ"};